module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjE1IiB2aWV3Qm94PSIwIDAgOCAxNSI+CiAgICA8cGF0aCBmaWxsPSIjOUI5QjlCIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0uNzI0IDEuMjk3bDYuMTEgNi40Mi02LjExIDYuNDJhLjUzMy41MzMgMCAwIDAgMCAuNzI3Yy4xOS4yMDEuNS4yMDEuNjkxIDBsNi40NTctNi43ODNhLjUyNi41MjYgMCAwIDAgLjE0My0uMzY0LjUyNS41MjUgMCAwIDAtLjE0My0uMzYzTDEuNDE1LjU3Yy0uMTktLjItLjUtLjItLjY5MSAwYS41MzIuNTMyIDAgMCAwIDAgLjcyNyIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/task-navigate.svg
// module id = 153
// module chunks = 0